import TourTooltip from 'elements/tooltip/TourTooltip'
import { TourConfigType } from 'persistentContent/tours/types'
import { useTranslate } from 'ra-core'
import { FC } from 'react'

const StepTooltip: FC = (props) => {
  const translate = useTranslate()
  return (
    <TourTooltip
      title={translate("You're All Set!")}
      subtext={translate(
        "You're ready to use Ada! Try asking questions, requesting actions, or using voice mode. Ada is here to help you work faster and smarter in OpenSolar."
      )}
      {...props}
    />
  )
}

const Finish: TourConfigType = {
  spotlights: [{ targetId: 'Ada-Chat-Input', autoScroll: true }],
  tooltips: [
    {
      targetId: 'Ada-Chat-Input',
      placement: 'top',
      component: StepTooltip,
      options: { style: { marginBottom: 10 } },
    },
  ],
}

export default Finish

